module.exports = __webpack_public_path__ + "img/logo.8ccaf94c.png";